import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const BASE = `${u}/assigned-tasks`;

export const createTask = async (data) => {
  const res = await apiFetch(BASE, { method: "POST", body: JSON.stringify(data) });
  return res.json();
};

export const updateTask = async (id, data) => {
  const res = await apiFetch(`${BASE}/${id}`, { method: "PUT", body: JSON.stringify(data) });
  return res.json();
};

export const deleteTask = async (id) => {
  await apiFetch(`${BASE}/${id}`, { method: "DELETE" });
};

export const getTaskById = async (id) => {
  const res = await apiFetch(`${BASE}/${id}`);
  return res.json();
};

export const listCreatedTasks = async () => {
  const res = await apiFetch(`${BASE}/created`);
  if (!res.ok) return [];
  return res.json();
};

export const listAssignedToMe = async () => {
  const res = await apiFetch(`${BASE}/assigned-to-me`);
  if (!res.ok) return [];
  return res.json();
};

export const sendNotification = async (id) => {
  await apiFetch(`${BASE}/${id}/notify`, { method: "POST" });
};
